import * as React from 'react';

import { DealTypeFilterContainer } from '../../containers/DealTypeFilterContainer';
import { EntityTypeToggleContainer } from '../../containers/EntityTypeToggleContainer';
import { FoldersUnsupportedModalContainer } from '../../containers/FoldersUnsupportedModalContainer';
import { ResultsEmptyContainer } from '../../containers/ResultsEmpty';
import { ResultsMobileContainer } from '../../containers/ResultsMobileContainer';
import { ShowMoreBtnContainer } from '../../containers/ShowMoreBtnContainer';

export const MobilePage = () => {
  return (
    <>
      <DealTypeFilterContainer />
      <EntityTypeToggleContainer />
      <ResultsMobileContainer />
      <ResultsEmptyContainer />
      <ShowMoreBtnContainer />
      <FoldersUnsupportedModalContainer />
    </>
  );
};
